﻿cb.define(['common/common_VM.Extend.js'], function (common) {
  var ST_st_othoutrecord_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
		debugger;

		//条码扫描相关-------Begin-------------------------------------
		//初始化barcode 
		common.initBarcodeModel(viewmodel);
		//扫码
		viewmodel.get("barcode").on('enter', function (data) {
			//字段对照
			var fields = {
				mainid: 'mainid',
				product: 'product',
				productcode: 'product_cCode',
				productname: 'product_cName',
				productsku: 'productsku',
				barcode: 'barcode',
				batchno: 'batchno',
				producedate: 'producedate',
				invaliddate: 'invaliddate',
				productskucode: 'productsku_cCode',
				weight: 'weight',
				quantity: 'quantity',
				unit: 'unit',
				unitname: 'product_unitName',//'unitName',
				// "accountWeight": 'accountWeight',
				// "accountPrice": pData.productskus[0].skuSalePrice,
				isbatch: 'isBatchManage'
			};
			return common.onBarCodeEnter(data, viewmodel, fields);

			// return common.onBarCodeEnter(data, viewmodel, fields, afterBarcodeEnter);
		});

		// var afterBarcodeEnter = function (result) {
		// 	debugger;
		// 	cb.utils.alert('afterBarcodeEnter');
		// 	return;

		// };
		//条码扫描相关-------End-------------------------------------

		var detailsModel = viewmodel.get("othOutRecords");
		if(detailsModel){
			//向后台传递行号
			detailsModel.setState('orderField', 'rowno');
			detailsModel.on('rowColChange', function(args) {
			//其他出库单生效日期和失效日期不可编辑
				if (args.value.columnKey == 'producedate' || args.value.columnKey == 'invaliddate') {
					  return false;
				}
				return common.bacthnoAndExpiryDateManage(args, detailsModel);
			});
			//批次参照弹出前事件，看一下商品是否启用批次管理，如果未启用，那么不弹出批次参照
			detailsModel.on('beforeBrowse', function(args) {
			debugger
			if(args.cellName == 'batchno'){
					var rows = detailsModel.getRows();
					var rowIndex = args.rowIndex;
					var row = rows[rowIndex];
					if(row.isBatchManage == true){

					}else{
						return false;
					}
				}
			});
			//单元格值改变以后，如果是商品变了，就清空批次号、生效日期、失效日期
			detailsModel.on('afterCellValueChange', function (data){
				switch (data.cellName) {
					case "productsku_cCode":
					case "productsku_cName":
					case "product_cCode" :
					case "product_cName" : {
						detailsModel.setCellValue(data.rowIndex, 'batchno', null);
						detailsModel.setCellValue(data.rowIndex, 'producedate',  null);
						detailsModel.setCellValue(data.rowIndex, 'invaliddate',  null);
						for(var i = 1; i <= 30 ; i ++)
						{
							detailsModel.setCellValue(data.rowIndex, 'define'+i, null);
							detailsModel.setCellValue(data.rowIndex, 'prodefine'+i, null);						
						}
						break;
					}
				}
			})
			//单元格值改变以前
			detailsModel.on('beforeCellValueChange', function (data){
				switch (data.cellName) {
					case "quantity":{
						if (data.value <= 0 || data.value == '-') {
							cb.utils.alert("["+detailsModel.getColumn("quantity").cShowCaption+"]只能录入大于0的值，请检查后重试！");
							return false;
						}	
						break;						
					}
				}
			})
			//增行时，表头单据日期，带入表体入库日期
			detailsModel.on('beforeInsertRow', function (data) {
				debugger
				var	vouchdate=this.getParent().get("vouchdate").getValue();
				data.row['recorddate']=vouchdate;
			});
		}
      	//保存之前
		viewmodel.on('beforeSave', function (args){
			
		});
		//数据加载后
		viewmodel.on('afterLoadData', function() {
			
			if (cb.rest.AppContext.user.userType==0)
			{
				viewmodel.get('store_name').setVisible(true);
			}
			else
			{
				viewmodel.get('store_name').setVisible(false);
			}
			var mode = viewmodel.getParams().mode;
			if(mode == "add")
				viewmodel.get("status").setVisible(false);
			else
				viewmodel.get("status").setVisible(true);			
		});		


    }
  }
  try {
    module.exports = ST_st_othoutrecord_VM_Extend;
  } catch (error) {

  }
  return ST_st_othoutrecord_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_othoutrecord_VM.Extend.js